const appData ={
    account_type: 'individual',
    sub_account_type: '',
    email: '',
    password: '',
    confirm_password: '',
    hear_about_us: '',
    citizenship_status: '',
    app_id: '',
    specialtyAccountType: 'C',
    country_of_birth: '',
    country_of_residence: '',
    country_of_citizenship: '',
    clientIP: ''
}

const SET_REGISTER_INFO = 'SET_REGISTER_INFO';
const SET_SPECIALTY_ACCOUNT_TYPE = 'SET_SPECIALTY_ACCOUNT_TYPE';

export const setAppData = (appData) => ({
    type: SET_REGISTER_INFO,
    payload: appData,
});

export const setSpecialtyAccountType = (specialtyAccountType) => ({
    type: SET_SPECIALTY_ACCOUNT_TYPE,
    payload: specialtyAccountType,
});

const register_store = (state = appData, action) => {
    switch (action.type) {
        case SET_SPECIALTY_ACCOUNT_TYPE:
            return {
                ...state,
                specialtyAccountType: action.payload,
            };
        case SET_REGISTER_INFO:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};

export default register_store;
